import {
  useCallback,
  useEffect,
  useMemo, useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { orderBy } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getDistinctAccountsList } from '../../features';
import { getDate } from '../../utils/getDate';

const currentDate = getDate();

function useCustomObject() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { accountId, accountName } = location?.state ?? {};
  const accountListData = useSelector((state) => state.distinctAccountsList?.data);
  const [selectedFilters, setSelectedFilters] = useState({
    timeFrame: '30days',
    account: accountId && accountName ? { id: accountId, name: accountName, value: accountId } : null,
  });

  // State to store API data ----->
  const [accountList, setAccountList] = useState([]);

  useEffect(() => {
    dispatch(getDistinctAccountsList());
  }, []);

  // State setter functions ----->
  const setAccountListData = () => {
    const filteredAccount = [];
    const accountsWithoutName = [];
    if (accountListData?.length) {
      accountListData.forEach((acc) => {
        const isActive = acc.status === 'Active';
        const isNeverExpire = acc.renewalDate === null;
        const isRenewalDateValid = acc.renewalDate && getDate(acc.renewalDate) >= currentDate.setHours(0, 0, 0, 0);

        if (isActive && (isRenewalDateValid || isNeverExpire)) {
          const object = {};
          object.value = acc.accountId;
          object.name = acc.accountName;
          object.id = acc.accountId;
          if (!acc.accountName) {
            accountsWithoutName.push(object);
          } else {
            filteredAccount.push(object);
          }
        }
      });
    }
    const sortedData = orderBy(filteredAccount, ['name'], ['asc']);
    setAccountList([...sortedData, ...accountsWithoutName]);
  };

  useEffect(() => {
    setAccountListData();
  }, [accountListData]);

  // To handle filters
  const dropDown = useMemo(() => {
    const timeFrame = [
      { id: 1, value: '15days', name: '15 Days' },
      { id: 2, value: '30days', name: '30 Days' },
      { id: 3, value: '60days', name: '60 Days' },
    ];
    const accountMenuList = accountList;

    return { timeFrame, accountMenuList };
  }, [accountList]);

  const handleFilterChange = useCallback((name, value) => {
    setSelectedFilters((prev) => ({ ...prev, [name]: value }));
  }, []);

  return {
    dropDown,
    selectedFilters,
    handleFilterChange,
  };
}

export default useCustomObject;
